import DOMPurify from "dompurify";

const normalizeHtml = (html: string): string => {
  if (!html) {
    return "";
  }

  const parser = new DOMParser();
  const documentNode = parser.parseFromString(html, "text/html");
  const gtcNode = documentNode.querySelector("#GTC");
  const bodyHtml = documentNode.body?.innerHTML?.trim();

  if (gtcNode?.innerHTML?.trim()) {
    return gtcNode.innerHTML;
  }

  return bodyHtml || html;
};

const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(normalizeHtml(html), {
    USE_PROFILES: { html: true },
  });
};

export default sanitizeHtml;
